<template>
   <div class="header">
      <a href='/'>
         <img src="../../assets/commentoid_text_logo.png" height="42px" class="logo-text">
      </a>
   </div>
</template>

<script>
export default {
   name: 'Landing',
   props: ['title'],
   data () {
      return {

      }
   },
   methods: {
      preventMouseDown: (e) => {},
      navigateToHome: (ev) => {
         window.location = '/';
      }
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
   display: flex;
   align-items: center;
   justify-content: center;
   width: 100%;
   max-width: inherit;  
   border-bottom: solid 1px #EEEEEE; /* COLOR LIGHT GREY */
   background: #FDFDFD; /* COLOR BODY CREAM ZEN */
   height: 3rem;
   margin-top: 0.7rem;
}

.header-left {
   height: 60px;
   display: flex;
   align-items: center;
}

.header-right {
   height: 60px;
   display: flex;
   align-items: center;
   justify-content: flex-end;
}

.logo-square {
   padding-right: 0.5rem;
}

.logo-text {

}

.login-button-small-container {
   padding: 4px;
   margin: 4px;
   padding-right: 1em;
}

@media screen and (max-width: 70rem) {
   .header-left {
      padding-left: 2rem;
   }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue